import styled from "styled-components";

export const CtaBox = styled.div`
  padding: 0px 20px;
  padding-top: 20px;
  & > div {
    padding-top: 0px;
  }
  & h2 {
    color: #373737;
  }
`;

export const Install = styled.div`
  padding: 10px;
  border: 2px dashed #ccc;
  border-radius: 10px;
  margin: 5px;
  & > div:first-child {
    display: flex;
    gap: 10px;
    font-size: 14px;
    align-items: center;
    & p {
      margin: 0;
    }
  }
  & > div:last-child {
    margin-top: 10px;
  }
  & img {
    width: 45px;
    height: 50px;
  }
`;
